import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, BookOpen } from 'lucide-react';
import { tomosData } from '../data/tomos';
export function TomosAccordion() {
  const [openId, setOpenId] = useState<number | null>(null);
  const toggleAccordion = (id: number) => {
    setOpenId(openId === id ? null : id);
  };
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-139">
      <div className="text-center mb-12" data-id="element-140">
        <h2 className="text-4xl sm:text-5xl font-display text-white mb-4" data-id="element-141">
          ¿Qué incluye <span className="text-trek-orange" data-id="element-142">esta guía?</span>
        </h2>
        <p className="text-trek-beige text-lg" data-id="element-143">
          Todo lo que necesitás saber, organizado paso a paso.
        </p>
      </div>

      <div className="space-y-4" data-id="element-144">
        {tomosData.map(tomo => <div key={tomo.id} className={`border rounded-xl overflow-hidden transition-colors duration-300 ${openId === tomo.id ? 'border-trek-orange bg-trek-blackLight' : 'border-trek-brown bg-trek-black/50 hover:border-trek-brownLight'}`} data-id="element-145">
            <button onClick={() => toggleAccordion(tomo.id)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-146">
              <div className="flex items-start gap-4 pr-4" data-id="element-147">
                <div className={`p-2 rounded-lg mt-1 ${openId === tomo.id ? 'bg-trek-orange text-white' : 'bg-trek-brown text-trek-beige'}`} data-id="element-148">
                  <BookOpen size={20} data-id="element-149" />
                </div>
                <div data-id="element-150">
                  <h3 className="text-xl sm:text-2xl font-display text-white mb-1" data-id="element-151">
                    {tomo.title}
                  </h3>
                  <p className="text-trek-orangeLight font-medium text-sm sm:text-base" data-id="element-152">
                    {tomo.tagline}{' '}
                    <span className="text-trek-beige/50 ml-2 font-normal" data-id="element-153">
                      ({tomo.pages} páginas)
                    </span>
                  </p>
                </div>
              </div>
              <ChevronDown size={24} className={`text-trek-beige flex-shrink-0 transition-transform duration-300 ${openId === tomo.id ? 'rotate-180 text-trek-orange' : ''}`} data-id="element-154" />
            </button>

            <AnimatePresence data-id="element-155">
              {openId === tomo.id && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-156">
                  <div className="px-6 pb-6 pt-2 border-t border-trek-brown/30" data-id="element-157">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4" data-id="element-158">
                      {tomo.chapters.map((chapter, idx) => <div key={idx} className="bg-trek-black p-4 rounded-lg border border-trek-brown/20" data-id="element-159">
                          <h4 className="font-bold text-trek-orange mb-3 text-sm uppercase tracking-wide" data-id="element-160">
                            {chapter.title}
                          </h4>
                          <ul className="space-y-2" data-id="element-161">
                            {chapter.topics.map((topic, tIdx) => <li key={tIdx} className="text-trek-beige text-sm flex items-start gap-2" data-id="element-162">
                                <span className="text-trek-orange/50 mt-1 text-[10px]" data-id="element-163">
                                  ▶
                                </span>
                                <span className="leading-snug" data-id="element-164">{topic}</span>
                              </li>)}
                          </ul>
                        </div>)}
                    </div>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </section>;
}